import React from 'react';
import PropTypes from 'prop-types';
import { TableSubtleFetchBar } from '../TableSkeleton/TableSkeleton';

import './ListTableSoftRefreshFrame.scss';

/**
 * Soft refresh: optional leading slot, then thin indeterminate bar, then dimmed body.
 */
const ListTableSoftRefreshFrame = ({ showSubtleFetch, leadingContent, children, className }) => (
    <div
        className={[
            'ListTableSoftRefreshFrame',
            showSubtleFetch ? 'ListTableSoftRefreshFrame--busy' : '',
            className || '',
        ]
            .filter(Boolean)
            .join(' ')}
    >
        {leadingContent ? (
            <div className="ListTableSoftRefreshFrame__leading">{leadingContent}</div>
        ) : null}
        {showSubtleFetch && (
            <div className="ListTableSoftRefreshFrame__bar" aria-hidden="true">
                <TableSubtleFetchBar />
            </div>
        )}
        <div className="ListTableSoftRefreshFrame__body">{children}</div>
    </div>
);

ListTableSoftRefreshFrame.propTypes = {
    showSubtleFetch: PropTypes.bool,
    leadingContent: PropTypes.node,
    children: PropTypes.node,
    className: PropTypes.string,
};

ListTableSoftRefreshFrame.defaultProps = {
    showSubtleFetch: false,
    leadingContent: null,
    children: null,
    className: '',
};

export default ListTableSoftRefreshFrame;
